module.exports = "//static.hsappstatic.net/page-editor-ui/static-1.4772/img/mab/copy.gif"